/***********************************************************************
Use            : Global or static functions
Created By     : ATP-0000850
Created Date   : 13-APR-2020
Updated By     : ATP-0000850
Updated Date   : 13-APR-2020
***********************************************************************/
import * as _ from 'lodash';
import { Summary } from '@/entities'
import moment from 'moment';
import { AppConstants as _app } from '@/shared/app.constants';

export class Utilities {
    /** format value to the formatted number string */
    static formatDecimal (value, dec = 0, locale) {
        return Intl.NumberFormat(locale, {
            minimumFractionDigits: dec
        }).format(value);
        //return value;  
    }    

    /** format value to the target currency format */
    static formatCurrency (value, currency, locale) {
        if(value || value == 0) {
        value = this.truncateDecimalPlace(value);
        
        if (value || value == 0) {
        return Intl.NumberFormat(locale, { 
            style: 'currency', 
            currency: currency || 'EUR', 
            minimumFractionDigits: 2
        }).format(value); 
            
        } else {return '-'; }
    }
    else {
        return '';
    }
    }

    /** format value to the target currency format */
    static formatCurrency2 (value, currency) {
        return this.truncateDecimalPlace(value);
    }

    // Truncate number to two decimal places without rounding
    static truncateDecimalPlace (num) {
        if (num) {
        num = num.toString(); //If it's not already a String
        if (num.indexOf(".") > 0) {
            num = num.slice(0, (num.indexOf(".")) + 3); //With 3 exposing the hundredths place
        }}
        return num;
    }

    // Returns the currency format that autonumeric package can process
    static currencyHandler = (value) => {
        switch (value) {
            case "EUR": return '€ '
                break;
            case "USD": return '$ '
                break;
            case "CHF": return '\u202fCHF '
                break;
        }
    }

    static getParameterByName(name: string) {
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(location.search);
        return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    // #. parse the JSON string
    static parseJSON(val: any) {
        if(!val) 
            return {};

        if(typeof(val) == 'object')
            return val;

        var data = JSON.parse(val);

        if(typeof(data) == 'string')
            return this.parseJSON(data);
        else
            return data;
    }
    // #. Method for create the GUIDs
    public static generateGUID() {
        let d = new Date().getTime();
        // g if (window.performance && typeof window.performance.now === 'function') {
        //   d += performance.now(); // use high-precision timer if available
        // }
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    }
    // /** return the summary (percentage completed) */
    // static getSummary(template: any, data: any ): any {
    //     let summary: any = { totalProps: 0, filledProps: 0, missingProps: [], invalidProps: [] }
    // }

    /** return whether the param is object */
    public static isObject(objValue) {
        return objValue && typeof objValue === 'object' && objValue.constructor === Object;
    }

    public static isEmpty(objValue) {
        return _.isEmpty(objValue);
    }

    /** Get the month difference */
    public static monthDiff(d1, d2) {
        let months;
        const m = moment(d1);
        const n = moment(d2);
        months = Math.round(n.diff(m, 'months', true));

        /*let startDate = new Date(d1);
        let endDate = new Date(d2);
        months = ( endDate.getFullYear() -  startDate.getFullYear() ) * 12;
        months -= startDate.getMonth();
        months += endDate.getMonth();*/
        return months <= 0 ? 0 : months;
    }
    public static addMonths(d1,duration)
    {
        let months;
        const m= moment(d1);
        months=m.add(duration,'M');
        return months;
    }

    public static diffDays(d1,d2)
    {
        const m = moment(d1);
        const n = moment(d2);
        let days = Math.round(m.diff(n, 'days', true));
        return days;

    }

    /** calculate summary info */
    static calculateSummary(template: any, data: any, summaryInfo: Summary) {

        for(const key in template.properties) {
            const prop = template.properties[key];

            if( prop['x-virtual'] ) {
                summaryInfo = this.calculateSummary(prop, data, summaryInfo)
            } else {
                summaryInfo.propsCount += 1; 
                
                if(Object.keys(data).length > 0) {

                    switch(prop.type) {
                        case "boolean":
                        case "number":
                            if(data[key] !== null && data[key] !== undefined) {
                                summaryInfo.filledProps += 1;                                
                            } else {                                
                                summaryInfo.missingProps.push(key);
                            }
                            break;
                        default:
                            if(_.isEmpty(data[key])){
                                if(prop.required){
                                    summaryInfo.missingProps.push(key);
                                }
                            } else {
                                summaryInfo.filledProps += 1;
                            }
                            break;
                    }

                }                                
            }
        }
        
        return summaryInfo;
    }

    /** clone the object */
    static clone(data: any) {
        return JSON.parse(JSON.stringify(data));
    }

    /** date conversion (UTC to local) with UTC annotation*/
    public static dateFormat(date: any, format?: string) {
        return `${moment(date).format((format || _app.defaultTimeFormat.time))} ${_app.defaultTimeFormat.standard}`;
    }

    /** set the nested value */
    public static setValue (propertyPath, value, obj) {

        // this is a super simple parsing, you will want to make this more complex to handle correctly any path
        // it will split by the dots at first and then simply pass along the array (on next iterations)
        let properties = Array.isArray(propertyPath) ? propertyPath : propertyPath.split(".")
      
        // Not yet at the last property so keep digging
        if (properties.length > 1) {
          // The property doesn't exists OR is not an object (and so we overwritte it) so we create it
          if (!obj.hasOwnProperty(properties[0]) || typeof obj[properties[0]] !== "object") obj[properties[0]] = {}
            // We iterate.
          return this.setValue(properties.slice(1), value, obj[properties[0]])
            // This is the last property - the one where to set the value
        } else {
          // We set the value to the last property
          obj[properties[0]] = value
          return true // this is the end
        }
      
      }

    /** get nested value */
    public static getNestedValue(datum: any, path: string) {
        if(!datum)
            return undefined;

        if(!path)
            return datum;

        return _.get(datum, path, undefined );
    }

    /** get the formatted date time */
    public static formatDateTime(val: any) {
        return `${moment(val).format(_app.defaultTimeFormat.time)} ${_app.defaultTimeFormat.standard}`;
    }

    /*** format date string to dd/mm/yyyy format */
    public static formatDate(date: any) {
        return moment(date).format(_app.defaultTimeFormat.date)
    }

    /** get the earliest date */
    public static getMinDate(d1: any, d2: any) {
        return new Date(d1) < new Date(d2) ? d1 : d2;
    }

    /** round value to the formatted number */
    static roundDecimal (value) {
        return Math.round((value + Number.EPSILON) * 100) / 100;
        //return value; 
    }
}